import angular from 'angular'

/**
 * Directive for preventing widow's. Employ's the vdRemoveWidow filter.
 *
 * @module vend.ui.vdNoWidow
 */
angular
  .module('vend.ui')
  .directive('vdNoWidow', function (vdRemoveWidowFilter) {
    return {
      restrict: 'A',
      link(scope, $element) {
        const documentEl = $element[0]
        const elementText = documentEl.innerText

        documentEl.innerText = vdRemoveWidowFilter(elementText)
      },
    }
  })
